/**
 * Configuration for the app.
 */
/* tslint:disable */

// Feature flags.
const APP_FEATURES = {
  READ_ONLY_MODE: false,
  NEWSLETTER_FEATURE_ACTIVE: false,
  LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
  GOOGLE_OAUTH_FEATURE_ACTIVE: false,
  FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
  OKTA_OAUTH_FEATURE_ACTIVE: false,
  KEYCLOAK_OAUTH_FEATURE_ACTIVE: false,
  ENTRA_OAUTH_FEATURE_ACTIVE: false,
  GDPR_CONSENT_FEATURE_ACTIVE: true,
  GDPR_CONSENT_MODAL_SHOW_CLOSE: true,
  GDPR_CONSENT_MODAL_SHOW_NEWSLETTER: false,
  GDPR_CONSENT_LATEST_TC_ACTIVE: false,
  PATH_TRANSLATIONS_ACTIVE: false,
  PATH_FORCE_LOWERCASE: true,
  LANDING_PAGE_ADS_ACTIVE: false,
  ORDER_ADDITIONAL_INFO_FIELD: true,
  SHOW_GA4_STATISTICS: true,
  EURO_VAT_SYSTEM: true,
  BLOG_FEATURE_ACTIVE: false,
  BLOG_ADS_FEATURE_ACTIVE: false,
  SHOW_POWERED_BY_FOOTER: true,
  JOBIQO_AIR_TRACKING_FEATURE_ACTIVE: true,
  LANDING_PAGE_BUTTONS_VERTICAL_MOBILE: false,
  CHECKOUT_FREE_ORDER_AUTOSUBMIT: false,
  CONVERSION_API_ENABLED: false,
};

// Price currency spacing and placement configuration.
const PRICE_CONFIG = {
  // Defines currency placement against price value.
  CURRENCY_PLACEMENT: 'after',
  // Defines if price value should be spaced from currency.
  USE_SPACING: true,
};

// Duplicated because js can't import from ts files.
const allowedCmpProviders = {
  Usercentrics: 'Usercentrics',
  OneTrust: 'OneTrust',
  ConsentManager: 'ConsentManager',
  TrustCommander: 'TrustCommander',
  Traffective: 'Traffective',
  Didomi: 'Didomi',
  CivicCookieControl: 'CivicCookieControl',
};

module.exports = {
  public: {
    BASE_PATH: false,
    // Selects the bundler for both production builds and development.
    TURBOPACK_BUILD: false,
    READ_ONLY_MODE: APP_FEATURES.READ_ONLY_MODE,
    NEWSLETTER_FEATURE_ACTIVE: APP_FEATURES.NEWSLETTER_FEATURE_ACTIVE,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: APP_FEATURES.LINKEDIN_OAUTH_FEATURE_ACTIVE,
    GOOGLE_OAUTH_FEATURE_ACTIVE: APP_FEATURES.GOOGLE_OAUTH_FEATURE_ACTIVE,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: APP_FEATURES.FACEBOOK_OAUTH_FEATURE_ACTIVE,
    OKTA_OAUTH_FEATURE_ACTIVE: APP_FEATURES.OKTA_OAUTH_FEATURE_ACTIVE,
    OKTA_SSO_BUTTON_LOGO: null,
    KEYCLOAK_OAUTH_FEATURE_ACTIVE: APP_FEATURES.KEYCLOAK_OAUTH_FEATURE_ACTIVE,
    KEYCLOAK_SSO_BUTTON_LOGO: null,
    ENTRA_OAUTH_FEATURE_ACTIVE: APP_FEATURES.ENTRA_OAUTH_FEATURE_ACTIVE,
    ENTRA_SSO_BUTTON_LOGO: null,
    SOCIAL_BUTTONS_ORDER: [
      'linkedin',
      'google',
      'facebook',
      'okta',
      'keycloak',
      'entra',
    ],
    SOCIAL_ICONS_COLORED: true,
    SHARING_BUTTONS_ENABLED: [
      'facebook',
      'linkedin',
      'email',
      'twitter',
      'whatsapp',
      'xing',
      'bluesky',
    ],
    GDPR_CONSENT_FEATURE_ACTIVE: APP_FEATURES.GDPR_CONSENT_FEATURE_ACTIVE,
    GDPR_CONSENT_MODAL_SHOW_CLOSE: APP_FEATURES.GDPR_CONSENT_MODAL_SHOW_CLOSE,
    GDPR_CONSENT_MODAL_SHOW_NEWSLETTER:
      APP_FEATURES.GDPR_CONSENT_MODAL_SHOW_NEWSLETTER,
    GDPR_CONSENT_LATEST_TC_ACTIVE: APP_FEATURES.GDPR_CONSENT_LATEST_TC_ACTIVE,
    PATH_TRANSLATIONS_ACTIVE: APP_FEATURES.PATH_TRANSLATIONS_ACTIVE,
    PATH_FORCE_LOWERCASE: APP_FEATURES.PATH_FORCE_LOWERCASE,
    LANDING_PAGE_ADS_ACTIVE: APP_FEATURES.LANDING_PAGE_ADS_ACTIVE,
    ORDER_ADDITIONAL_INFO_FIELD: APP_FEATURES.ORDER_ADDITIONAL_INFO_FIELD,
    SHOW_GA4_STATISTICS: APP_FEATURES.SHOW_GA4_STATISTICS,
    EURO_VAT_SYSTEM: APP_FEATURES.EURO_VAT_SYSTEM,
    CHECKOUT_FREE_ORDER_AUTOSUBMIT: APP_FEATURES.CHECKOUT_FREE_ORDER_AUTOSUBMIT,
    BLOG_FEATURE_ACTIVE: APP_FEATURES.BLOG_FEATURE_ACTIVE,
    BLOG_ADS_FEATURE_ACTIVE: APP_FEATURES.BLOG_ADS_FEATURE_ACTIVE,
    SHOW_POWERED_BY_FOOTER: APP_FEATURES.SHOW_POWERED_BY_FOOTER,
    JOBIQO_AIR_TRACKING_ACTIVE: APP_FEATURES.JOBIQO_AIR_TRACKING_FEATURE_ACTIVE,
    AT_NET: {
      // Set to this site's AT network partner name to enable network tracking.
      AT_NET_PARTNER_NAME: null,
    },
    LANDING_PAGE_BUTTONS_VERTICAL_MOBILE:
      APP_FEATURES.LANDING_PAGE_BUTTONS_VERTICAL_MOBILE,
    CAPTCHA: {
      REGISTER: false,
      JOB_APPLICATION: false,
    },
    SITENAME: 'Jobiqo decoupled',
    SITE_DESCRIPTION:
      'Jobiqo decoupled is a machine learning platform for job boards',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      location: { lat: 51, lng: 10 },
      radius: 500,
      // Bounds take precedence over location + radius.
      bounds: { swlat: null, swlng: null, nelat: null, nelng: null },
      queryDelay: 250,
      minLength: 1,
      country: null,
      disableSuggests: false,
    },
    GOOGLE_MAPS_LIBRARIES: ['places'],
    GOOGLE_GEOSUGGEST_CONSENT: false,
    CUSTOM_FONTS: false,
    GTC_LINK: null,
    GTM_CONTAINER_ID: null,
    GTM_SCRIPT_URL: 'https://www.googletagmanager.com/gtm.js',
    GTM_SCRIPT_STRATEGY: 'lazyOnload',
    GA4_MEASUREMENT_IDS: null,
    CMP_ID: null,
    CMP_PROVIDER: allowedCmpProviders.Usercentrics,
    CMP_PREF_BUTTON: false,
    CMP_TCF: false,
    USERCENTRICS_AUTOBLOCKER: false,
    TRUSTCOMMANDER_VERSION: null,
    TRAFFECTIVE_DOMAIN: null,
    TRAFFECTIVE_ACTIVATION_KEY: null,
    TRAFFECTIVE_PURPOSES_TO_CHECK: 11,
    ONETRUST_AUTOBLOCK_FEATURE: false,
    DIDOMI_SDK_URL: 'https://sdk.privacy-center.org/',
    DIDOMI_NOTICE_ID: null,
    CIVIC_COOKIE_CONTROL_PRODUCT: null,
    SNOWPLOW: {
      APP_ID: null,
      COLLECTOR_URL: null,
      POST_PATH: null,
      ENABLE_TRACKING: false,
      MINIMUM_VISIT_LENGTH: 5,
      HEARBEAT_DELAY: 5,
    },
    META_PIXEL_ID: null,
    OEWA: null,
    WEBTREKK_ID: null,
    FRONTENDS: {
      default: 'jobiqo',
    },
    SCHEMA: {
      ORGANIZATION: null,
    },
    PRICE_CONFIG,
    NON_LANDING_PAGE_PATHS: [
      '/jobs',
      '/job',
      '/resume',
      '/organization',
      '/user',
      '/contact',
      '/blog',
      '/checkout',
    ],
    PATH_FORCE_LOWERCASE_ALLOWED_PATHS: ['/jobs', '/organization'],
    OG_IMAGE: '/static/og-image.jpg',
    INTERNAL_SERVER_ERROR_IMAGE: '/static/500-error.svg',
    GEO_INFO: {
      fixtures: [],
    },
    CONTACT_FORM_SUBMIT_REDIRECT: {
      logged_in: '/dashboard',
      anonymous: '/',
    },
    FIELD_INFO: {
      contact_form: {
        key: 'contact_form',
        name: 'Contact us',
        fields: {
          id: 'id',
          name: 'name',
          mail: 'email',
          field_phone_number: 'phone',
          subject: 'subject',
          message: 'body',
          copy: 'copy',
          field_attachments: 'attachments',
        },
      },
    },
    ASSETS: {
      logo: '/static/logo.svg',
      loginImage: '/static/images/login-banner.jpg',
      registerImage: null,
      faviconsPath: '/static',
      progress: '/static/nprogress.css',
    },
    THEME: {
      colors: {
        primary: '#33bda6',
      },
      logo: {
        minHeight: 40,
        singlePageMaxHeight: 70,
      },
      SEARCH_FORM: {
        BUTTON_STYLE: 'primary',
      },
      JOB_ALERT: {
        BUTTON_STYLE: 'primary',
        BUTTON_BORDERED: true,
        BUTTON_RAISED: true,
      },
      NAVIGATION: {
        LOGO: null,
        SHOW_SIGN_IN_BUTTON: true,
        SIGN_IN_URL: '/user/login',
        SIGN_IN_BUTTON_STYLE: 'primary',
        MOBILE: {
          BUTTONS_STYLE: 'primary',
          SIDEBAR_LOGO: null,
          SHOW_SIGN_IN_BUTTON: true,
          SHOW_USER_MENU: true,
        },
        SHOW_USER_MENU_BUTTON: true,
      },
      LANDING_PAGES: {
        HERO_SPLIT_SCREEN: {
          PATTERN: true,
          CONTENT_MARGIN: [0, 12],
          SHADOW: true,
          HEADING_FONT_WEIGHT: 900,
        },
        HERO_SIMPLE_CENTERED: {
          IMAGE_PADDING: null,
          IMAGE_BG: null,
          SUBTITLE_FONT_SIZE: 4,
          SUBTITLE_LINE_HEIGHT: 5,
        },
        HERO_SEARCH_BANNER_FULL: {
          SUBTITLE_FONT_SIZE: 4,
          SUBTITLE_LINE_HEIGHT: 5,
        },
        FEATURE_CENTERED_2_COLS: {
          INTRO_BADGE: false,
          TEXT_ALIGN: 'center',
          ICON_COLOR: 'white',
          ICON_BOX_COLOR: null,
          ICON_BOX_SHADOW: null,
          ICON_BOX_RADIUS: null,
          ICON_TITLE_COLOR: null,
          ICON_TITLE_WEIGHT: 'bold',
          ICON_TEXT_COLOR: 'gray5',
          ICON_SIZE: 20,
        },
        JOB_TEASERS: {
          INTRO_BADGE: false,
          INTRO_COLOR: 'primary',
          INTRO_SECONDARY_COLOR: null,
          SHOW_ALL_BUTTON_STYLE: 'secondary',
        },
        VIDEO_JOB_TEASERS: {
          INTRO_BADGE: false,
          INTRO_COLOR: 'primary',
          INTRO_SECONDARY_COLOR: null,
          SHOW_ALL_BUTTON_STYLE: 'secondary',
        },
        ORGANIZATION_TEASERS: {
          INTRO_BADGE: false,
          INTRO_COLOR: 'primary',
          INTRO_SECONDARY_COLOR: null,
          SHOW_ALL_BUTTON_STYLE: 'secondary',
        },
        BLOG_TEASERS: {
          INTRO_BADGE: false,
          INTRO_COLOR: 'primary',
          INTRO_SECONDARY_COLOR: null,
          SHOW_ALL_BUTTON_STYLE: 'secondary',
        },
        FEATURE_GRID_ICONS: {
          TEXT_ALIGN: 'center',
          INTRO_BADGE: null,
          BOX_COLOR: 'gray0',
          BOX_TITLE_COLOR: null,
          ICON_COLOR: 'white',
          ICON_BOX_COLOR: null,
          ICON_BOX_SHADOW: null,
          ICON_BOX_RADIUS: null,
          ICON_SIZE: 20,
        },
        STATS_FADING_BG: {
          SHOW_GRADIENT: true,
          SHOW_BG_OVERLAY: true,
          SIDE_IMAGE_OPACITY: 0.3,
          SIDE_IMAGE_OBJECT_FIT: 'cover',
          CELL_1_TOP: false,
          SUBTITLE_ABOVE_TITLE: true,
          SUBTITLE_TITLE_SPACING: 'medium',
          TITLE_COLOR: 'white',
          SUBTITLE_TEXT_TRANSFORM: 'uppercase',
          SUBTITLE_COLOR: null,
          STAT_ICON_COLOR: 'white',
          STAT_TITLE_COLOR: 'white',
          STAT_TEXT_COLOR: 'white',
        },
        CTA_SIMPLE: {
          TITLE_ABOVE_SUBTITLE: true,
          SUBTITLE_FONT_SIZE: [5, 7],
          SUBTITLE_LINE_HEIGHT: [5, 6],
          SUBTITLE_FONT_WEIGHT: 'bold',
          SUBTITLE_COLOR: null,
        },
        LOGO_CLOUD_SIMPLE: {
          FULL_WIDTH: false,
          IMAGE_STYLE: 'medium',
          SHOW_DOTS: true,
          AUTOPLAY: false,
          SHOW_PLAY_PAUSE_BUTTON: true,
          SLIDES_TO_SHOW: 5,
          LOGO_SIZE: 200,
        },
        CARDS_SLIDER: {
          SHOW_DOTS: true,
        },
        PRODUCTS: {
          SHOW_DOTS: true,
        },
      },
      USER: {
        DANGER_ZONE: {
          BOX_BACKGROUND: null,
          BOX_BORDER_COLOR: 'danger',
        },
      },
      BLOG: {
        DETAIL: {
          BG: 'background',
          CONTAINER: 'large',
        },
        SEARCH_TAGS: {
          STYLE: 'primaryLight',
          SELECTED_STYLE: 'primary',
        },
        POPULAR_TAGS: {
          style: 'secondaryVeryLight',
        },
      },
    },
    FONTS: {
      OPTIMIZED: false,
    },
    GOOGLE_MEASUREMENT_API_ENABLED: false,
    ADDRESS_WIDGET_ORDER: [],
    SHOW_SECONDARY_FOOTER_LOGO: true,
    CUSTOM_SECONDARY_FOOTER_LOGO: null,
    POWERED_BY_LINK: 'https://www.jobiqo.com',
    POWERED_BY_TEXT: null,
    POWERED_BY_ATTRIBUTES: {
      target: '_blank',
    },
    FOOTER_SHOW_SOCIAL_LINKS: true,
    BRANDING_LOGO_LINK: '/',
    BROWSER_TAB_NOTIFICATION_MESSAGE: null,
    FACET_ITEMS_AUTOCOMPLETE_THRESHOLD: 30,
    CONVERSION_API_ENABLED: APP_FEATURES.CONVERSION_API_ENABLED,
    CONVERSION_API_ENABLED_EVENTS: [],
    ALLOW_EXACT_ADDRESS: true,
    HOTJAR_ID: null,
    DISABLED_LOGO_LINK_ROUTES: [],
    SENTRY: {
      project: 'jobiqo-decoupled',
      org: 'jobiqo8',
    },
    LEAFLET_MAP_ZOOM_LEVEL: 4.5,
    LANGUAGE_SWITCHER: {
      SHOW_FLAG: true,
      SHOW_LABEL: false,
      MAPPING: {},
    },
  },
  server: {
    SCOPES: 'applicant recruiter',
    SESSION_KEY: 'drupaljobsweb',
  },
};
